import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import FlatButton from '../tc-ui/flat-button-with-loader';
import { TextField, RaisedButton, Dialog, CircularProgress } from 'material-ui';
import { get } from '../../utils/http';
import checkStatus from '../../utils/checkStatus';
import $ from 'jquery';

const copyLink = (element) => {
  const $temp = $('<input>');
  $('body').append($temp);
  $temp.val($(element).text()).select();
  document.execCommand('copy');
  $temp.remove();
};

class GetInboundEmail extends React.Component {
  constructor() {
    super();
    this.state = {
      inboundEmail: '',
      dialogOpen: false,
      gettingInboundEmail: false,
    };
  }
  onButtonClick = () => {
    if (this.state.inboundEmail) this.setState({ dialogOpen: true });
    else {
      this.setState({ dialogOpen: true, gettingInboundEmail: true });
      get('/proxy/contracting/inboundEmail')
      .then(checkStatus)
      .then(res => res.json())
      .then(res => {
        this.setState({ inboundEmail: res.email, gettingInboundEmail: false });
      })
      .catch(err => {
        console.log(err);
        this.setState({ gettingInboundEmail: false });
      });
    }
  }
  closeDialog = () => this.setState({ dialogOpen: false, text: '' });
  render() {
    const { gettingInboundEmail, dialogOpen, inboundEmail, text } = this.state;
    const { ButtonElement, style, buttonStyle } = this.props;
    return (
      <div style={style}>
        <ButtonElement
          style={buttonStyle}
          loader={gettingInboundEmail}
          secondary
          label="Get Forwarding Email"
          onTouchTap={this.onButtonClick}
        />
        <Dialog
          style={{ padding: '0 2%', textAlign: 'center' }}
          open={dialogOpen}
          onRequestClose={this.closeDialog}
          actions={<div className="flex-tc-sb">
            <small>{text}</small>
            <div>
              <RaisedButton
                label="Copy Link"
                style={{ marginLeft: '8px' }}
                secondary
                onTouchTap={() => {
                  copyLink('#inboundEmail');
                  this.setState({ text: 'Link successfully copied!' });
                }}
              />
              <RaisedButton
                label="Dismiss"
                style={{ marginLeft: '8px' }}
                onTouchTap={this.closeDialog}
              />
            </div>
          </div>}
        >
          Ask your partner to send email to or cc this address.
          <br/>TourConnect will pick it up so you can work with the content of the email.
          <span id="inboundEmail" style={{ display: 'none' }}>{inboundEmail}</span>
          {
            inboundEmail ? <TextField
              id="inboundEmailField"
              value={inboundEmail}
              style={{ width: '100%' }}
              inputStyle={{ fontSize: '12px', textAlign: 'center' }}
              readOnly
            /> : <CircularProgress/>
          }
        </Dialog>
      </div>
    );
  }
}
GetInboundEmail.defaultProps = {
  style: {},
  buttonStyle: { float: 'right', marginRight: '2%' },
  ButtonElement: FlatButton,
};
GetInboundEmail.propTypes = {
  style: PropTypes.object,
  buttonStyle: PropTypes.object,
  ButtonElement: PropTypes.func,
};
const mapStateToProps = ({ contractingDashboard }) => ({
  showInboundEmail: contractingDashboard.showInboundEmail,
  inboundEmail: contractingDashboard.inboundEmail,
  gettingInboundEmail: contractingDashboard.gettingInboundEmail,
});

export default connect(mapStateToProps)(GetInboundEmail);



// WEBPACK FOOTER //
// ./src/app/components/messaging/getInboundEmail.jsx